import getConfig from 'next/config'
import { extractGaSessionId } from '../../../utils/extractGaSessionId'
import {
  getCurrentScreenName,
  getCurrentScreenSection,
  getPreviousScreenName,
  getPreviousScreenSection,
} from '../core/EventScreenManager'
import { EVENT_PARAM_KEY as EPK } from '../constants/EventParamKey'
import { getUTMPayload } from '../services/UTMService'
import { getConfigFor } from '../../../utils/configService'
import { SPLIT_FEATURES } from '../../../utils/constants/feature'
import SessionStorageService from '../../../utils/SessionStorageService'
import { getUtmPayload } from '../../segment'

const {
  publicRuntimeConfig: { ENVIRONMENT, GOOGLE_ANALYTICS_MEASUREMENT_ID },
} = getConfig()

interface GetUtmPayload {
  fbclid: string | null
  gclid: string | null
  referrer: string | null
  referring_domain: string | null
  utm_campaign: string | null
  utm_content: string | null
  utm_medium: string | null
  utm_source: string | null
  utm_term: string | null
}

export interface CommonEventParams {
  SESSION_ID_GA: string | null
  GCLID: string | null
  FBCLID: string | null
  REFERRER: string | null
  REFERRING_DOMAIN: string | null
  SCREEN_NAME: string | null
  SCREEN_SECTION: string | null
  PREVIOUS_SCREEN_NAME: string | null
  PREVIOUS_SCREEN_SECTION: string | null
  ENVIRONMENT: string | null
  // UTM parameters
  UTM_CAMPAIGN?: string | null
  UTM_CONTENT?: string | null
  UTM_MEDIUM?: string | null
  UTM_SOURCE?: string | null
  UTM_TERM?: string | null
}

export const CommonEventProperties = {
  SESSION_ID_GA: EPK.SESSION_ID_GA ?? null,
  GCLID: EPK.GCLID ?? null,
  FBCLID: EPK.FBCLID ?? null,
  REFERRER: EPK.REFERRER ?? null,
  REFERRING_DOMAIN: EPK.REFERRING_DOMAIN,
  SCREEN_NAME: EPK.SCREEN_NAME ?? null,
  SCREEN_SECTION: EPK.SCREEN_SECTION ?? null,
  PREVIOUS_SCREEN_NAME: EPK.PREVIOUS_SCREEN_NAME ?? null,
  PREVIOUS_SCREEN_SECTION: EPK.PREVIOUS_SCREEN_SECTION ?? null,
  ENVIRONMENT: EPK.ENVIRONMENT,
  // UTM parameters
  UTM_CAMPAIGN: EPK.UTM_CAMPAIGN,
  UTM_CONTENT: EPK.UTM_CONTENT,
  UTM_MEDIUM: EPK.UTM_MEDIUM,
  UTM_SOURCE: EPK.UTM_SOURCE,
  UTM_TERM: EPK.UTM_TERM,
}

export const getCommonParams = (): CommonEventParams => {
  const utmQuery = SessionStorageService.getItem('utm_payload')
  const data = utmQuery ? JSON.parse(utmQuery) : {}
  const utmPayload = getUtmPayload(data, true) as GetUtmPayload
  const { isEnabled = false } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_FIVE) ?? {}
  
  const commonParams: CommonEventParams = {
    SESSION_ID_GA: extractGaSessionId(GOOGLE_ANALYTICS_MEASUREMENT_ID),
    GCLID: utmPayload.gclid ?? null,
    FBCLID: utmPayload.fbclid ?? null,
    REFERRER: utmPayload.referrer ?? null,
    REFERRING_DOMAIN: utmPayload.referring_domain ?? null,
    SCREEN_NAME: getCurrentScreenName(),
    SCREEN_SECTION: getCurrentScreenSection(),
    PREVIOUS_SCREEN_NAME: getPreviousScreenName(),
    PREVIOUS_SCREEN_SECTION: getPreviousScreenSection(),
    ENVIRONMENT: ENVIRONMENT.toLowerCase() === 'prod' ? 'prod' : 'uat',
  }
  
  if (isEnabled) {
    const utmPayloadV2 = getUTMPayload()
    return {
      ...commonParams,
      UTM_CAMPAIGN: utmPayloadV2.utm_campaign ?? null,
      UTM_CONTENT: utmPayloadV2.utm_content ?? null,
      UTM_MEDIUM: utmPayloadV2.utm_medium ?? null,
      UTM_SOURCE: utmPayloadV2.utm_source ?? null,
      UTM_TERM: utmPayloadV2.utm_term ?? null,
    }
  }
  
  return commonParams
}
